import React from 'react';

const DomainExpertise = () => {
  return (
    <section className="sec build" id="build">
      <div className="wrap">
        <div className="build-header">
          <div className="rev">
            <div className="ey">Domain Expertise</div>
            <h2>Four industries.<br/><i>One mission.</i></h2>
          </div>
          <p className="sec-p rev d1">
            We specialise deeply — not broadly. Our AI products
            are built with genuine expertise in each domain,
            delivering outcomes that generic software never can.
          </p>
        </div>

        <div className="domain-grid">
          {/* Finance */}
          <div className="domain-card dc-fin rev">
            <div className="dc-icon">💳</div>
            <div className="dc-name">Financial Technology</div>
            <p className="dc-desc">
              Intelligent financial products that help individuals
              and businesses make smarter money decisions. From
              personal finance intelligence to enterprise financial
              analytics — AI that understands money the way humans do.
            </p>
            <div className="dc-pills">
              <span className="pill">Personal Finance AI</span>
              <span className="pill">Spend Intelligence</span>
              <span className="pill">Investment Insights</span>
              <span className="pill">Financial Planning</span>
            </div>
          </div>

          {/* E-Commerce */}
          <div className="domain-card dc-eco rev d1">
            <div className="dc-icon">🛒</div>
            <div className="dc-name">E-Commerce & Retail</div>
            <p className="dc-desc">
              AI-powered commerce tools that help businesses sell
              smarter and customers buy better. Demand forecasting,
              personalisation engines, inventory intelligence
              and pricing optimisation — at any scale.
            </p>
            <div className="dc-pills">
              <span className="pill">Demand Forecasting</span>
              <span className="pill">Personalisation</span>
              <span className="pill">Inventory AI</span>
              <span className="pill">Pricing Engine</span>
            </div>
          </div>

          {/* Banking */}
          <div className="domain-card dc-bnk rev d2">
            <div className="dc-icon">🏦</div>
            <div className="dc-name">Banking & Payments</div>
            <p className="dc-desc">
              Next-generation banking intelligence for financial
              institutions and fintechs. Fraud detection, credit
              scoring, payment optimisation and customer intelligence
              — built on modern AI infrastructure.
            </p>
            <div className="dc-pills">
              <span className="pill">Fraud Detection</span>
              <span className="pill">Credit Intelligence</span>
              <span className="pill">Payment AI</span>
              <span className="pill">Risk Modelling</span>
            </div>
          </div>

          {/* Human-Centric */}
          <div className="domain-card dc-hum rev d3">
            <div className="dc-icon">🧠</div>
            <div className="dc-name">Human-Centric Applications</div>
            <p className="dc-desc">
              AI products built around people — their emotions,
              their wellbeing, their relationships and their growth.
              Technology that understands what it means to be human
              and helps people live better lives.
            </p>
            <div className="dc-pills">
              <span className="pill">Wellness AI</span>
              <span className="pill">Emotional Intelligence</span>
              <span className="pill">Life Insights</span>
              <span className="pill">Family Apps</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DomainExpertise;
